import { trending } from "@/mocks/homeData";

export default function TrendingSection() {
  const [featured, ...rest] = trending;

  return (
    <section id="trending" className="w-full bg-background-100 py-14 md:py-20">
      <div className="w-full px-4 md:px-8">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4">
          <div className="max-w-2xl">
            <span className="inline-flex items-center gap-2 font-label text-xs text-primary-600 tracking-widest">
              <i className="ri-hotspot-line" />
              TRENDING
            </span>
            <h2 className="mt-3 font-heading font-black text-2xl md:text-4xl text-foreground-950">
              热门内容推荐
            </h2>
            <p className="mt-4 font-body text-sm md:text-base text-foreground-600 leading-relaxed">
              编辑每天从各频道挑出值得一读的内容，兼顾话题热度与信息质量。
            </p>
          </div>
          <a
            href="#ranking"
            className="whitespace-nowrap self-start md:self-auto cursor-pointer font-label text-sm px-5 py-2.5 rounded-md border border-foreground-300 text-foreground-800 hover:border-primary-400 hover:text-primary-600 transition-colors"
          >
            查看热度榜
          </a>
        </div>

        <div className="mt-8 grid grid-cols-1 lg:grid-cols-2 gap-5">
          <article className="group rounded-lg overflow-hidden border border-background-200 bg-background-50">
            <a href="#trending" className="cursor-pointer block">
              <div className="relative w-full h-56 md:h-72 overflow-hidden">
                <img
                  src={featured.image}
                  alt={featured.title}
                  title={`${featured.title} - 娱乐热点`}
                  className="w-full h-full object-cover object-top group-hover:scale-[1.02] transition-transform duration-500"
                />
                <span className="absolute top-4 left-4 font-label text-xs px-3 py-1.5 rounded-full bg-accent-500 text-secondary-950">
                  {featured.tag}
                </span>
              </div>
              <div className="p-5 md:p-6">
                <h3 className="font-heading font-bold text-xl md:text-2xl text-foreground-950 group-hover:text-primary-700 transition-colors">
                  {featured.title}
                </h3>
                <p className="mt-3 font-body text-sm text-foreground-600 leading-relaxed">
                  {featured.excerpt}
                </p>
                <p className="mt-4 font-label text-xs text-foreground-400">{featured.meta}</p>
              </div>
            </a>
          </article>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-5">
            {rest.map((item) => (
              <article
                key={item.id}
                className="group rounded-lg overflow-hidden border border-background-200 bg-background-50 flex flex-col"
              >
                <a href="#ranking" className="cursor-pointer flex flex-col h-full">
                  <div className="relative w-full h-36 overflow-hidden">
                    <img
                      src={item.image}
                      alt={item.title}
                      title={`${item.title} - 娱乐热点资讯`}
                      className="w-full h-full object-cover object-top group-hover:scale-[1.03] transition-transform duration-500"
                    />
                  </div>
                  <div className="p-4 flex flex-col flex-1">
                    <span className="self-start font-label text-[11px] px-2.5 py-1 rounded-full bg-primary-50 text-primary-600 border border-primary-100">
                      {item.tag}
                    </span>
                    <h3 className="mt-3 font-heading font-bold text-base text-foreground-950 group-hover:text-primary-700 transition-colors leading-snug">
                      {item.title}
                    </h3>
                    <p className="mt-2 font-body text-sm text-foreground-600 leading-relaxed flex-1">
                      {item.excerpt}
                    </p>
                    <p className="mt-3 font-label text-xs text-foreground-400">{item.meta}</p>
                  </div>
                </a>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}